import React from 'react';
export const Svg = ({ path, label, root }) => {
    const rootPath = root || '/images/sprites.svg';
    return (React.createElement("svg", { "aria-label": label },
        React.createElement("use", { href: `${rootPath}#${path}` })));
};
//# sourceMappingURL=Svg.js.map